// Grava pedido
$(function () {
  var pag_atual = $("#infos").data("param2");
  // Somente se for a página de pagamento
  if (pag_atual == "pagamento") {

    $("#concluir").removeAttr("disabled");

    function gravaLog(origem, msg_erro) {
      var dataString = { origem: origem, msg: msg_erro, acao: "log" };
      $.ajax({
        type: "POST",
        url: url_base + "acoes/app/pagamentos/grava_log.php?p=mercadopago",
        data: dataString,
        cache: false,
        success: function (response) { },
      });
    }

    function getBin() {
      var ccNumber = document.querySelector(
        'input[data-checkout="cardNumber"]'
      );
      return ccNumber.value.replace(/[ .-]/g, "").slice(0, 6);
    }

    var setPaymentMethodInfo = function (status, response) {
      if (status == 200) {
        if (response.error) {
          gravaLog("brand", JSON.stringify(response));
          $(".msg_invalido").show();
        } else {
          $(".msg_invalido").hide();
          $(".msg_invalido").hide();

          if ($("#paymentMethodId").length) {
            var payment_method = response[0].id;
            $("#paymentMethodId").val(payment_method);
            $("#bandeira").val(payment_method);

            /*$("#securityCode").attr(
            "min",
            "" + response[0].settings[0].security_code.length + ""
          );
          $("#securityCode").attr(
            "max",
            "" + response[0].settings[0].security_code.length + ""
          );*/

            $("#msg_securityCode").html(
              "<br>" +
              response[0].settings[0].security_code.length +
              " dígitos do verso"
            );
            $("#img_bandeira").html(
              "<img src='" + response[0].secure_thumbnail + "'>"
            );
            console.log(response[0]);
          } else {
            var payment_method = response[0].id;
            $("#paymentMethodId").val(payment_method);
            $("#bandeira").val(payment_method);

            /*$("#securityCode").attr(
            "min",
            "" + response[0].settings[0].security_code.length + ""
          );
          $("#securityCode").attr(
            "max",
            "" + response[0].settings[0].security_code.length + ""
          );*/

            $("#msg_securityCode").html(
              "<br>" +
              response[0].settings[0].security_code.length +
              " dígitos do verso"
            );
            $("#img_bandeira").html(
              "<img src='" + response[0].secure_thumbnail + "' width='50'>"
            );
            console.log(response[0]);
          }
        }
      }
    };

    function installmentHandler(status, response) {
      var max_parcelas = $("#max_parcelas").val();
      if (status != 200 && status != 201) {
        gravaLog("parcelamento", JSON.stringify(response));
      } else {
        if (response.error) {
          gravaLog("parcelamento", JSON.stringify(response));
        } else {
          $("#parcelas").html("");
          $.each(response[0].payer_costs, function (index, value) {
            //console.log(value.installments);
            var juros = this.installment_rate == 0 ? "( Sem juros )" : "";
            /* if (max_parcelas >= ++index) { */
            $("#parcelas").append(
              '<option value="' +
              this.installments +
              "x" +
              this.installment_amount +
              '">' +
              this.recommended_message +
              " " +
              juros +
              "</option>"
            );
            /* } */
          });
          console.log(response[0].payer_costs);
        }
      }
    }

    //mercado pago
    Mercadopago.getIdentificationTypes();

    //parcelamento
    function calculaParcelas() {
      $("#parcelas").html("");
      var bin = getBin();
      var amount = $("#valorPagto").val();
      Mercadopago.getPaymentMethod({ bin: bin }, setPaymentMethodInfo);
      Mercadopago.getInstallments(
        { bin: bin, amount: amount },
        installmentHandler
      );
    }

    //bandeira do cartão
    $("#numero_cartao").change(function () {
      calculaParcelas();
    });
    //bandeira do cartão

    //token do cartão
    function loadDocClean(input) {
      $("#docNumber").val(input.val().replace(/[ .-]/g, ""));
    }
    loadDocClean($(".docNumberComplete"));
    $(".docNumberComplete").on("input change keyup", function (event) {
      loadDocClean($(this));
    });

    $(".campos_cartao_token").on("change", function (event) {
      if (
        $("#numero_cartao").val() != "" &&
        $("#cvv").val() != "" &&
        $("#validadeMes").val() != "" &&
        $("#validadeAno").val() != "" &&
        $("#nome_cartao").val() != "" &&
        $("#docNumber").val() != ""
      ) {
        var form = document.querySelector("#form-pagamento");
        Mercadopago.createToken(form, mpResponseHandler);
        event.preventDefault();
        return false;
      }
    });

    var mpResponseHandler = function (status, response) {
      var $form = $("#form-pagamento");
      if (response.error) {
        gravaLog("token_cartao", JSON.stringify(response));
      } else {
        var card_token_id = response.id;
        $form.append(
          $(
            '<input type="hidden" id="card_token_id" name="card_token_id"/>'
          ).val(card_token_id)
        );
        $("#cartao_token").val(card_token_id);
      }
    };
    //token do cartão

    // Transfere dados para o formulário
    $(".finaliza-pedido").on("click", function () {
      var dta_nasc =
        $("#nascDia").val() +
        "/" +
        $("#nascMes").val() +
        "/" +
        $("#nascAno").val();
      $("#cvv_cartao_env").val($("#cvv").val());
      $("#numero_cartao_env").val($("#numero_cartao").val());
      $("#nome_cartao_env").val($("#nome_cartao").val());
      $("#parcelas_cartao_env").val($("#parcelas").val());
      $("#validademes_cartao_env").val($("#validadeMes").val());
      $("#validadeano_cartao_env").val($("#validadeAno").val());
      $("#cpf_cartao_env").val($("#cpf_cartao").val());
      $("#nasc_cartao_env").val(dta_nasc);
    });

    // Tranfere parcela para o formulário
    $("#parcelas").on("change", function () {
      $("#parcelas_cartao_env").val($("#parcelas").val());
    });

  }
});
